import Link from 'react-router-dom/Link'
import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { setBreadCrumbs } from '../../actions/breadcrumbs'

require('./mxprepareexperiment.css')

class MXNavigationContainer extends React.Component {
  render() {
    return (
      <div className="container">
        <div className="row">
          {this.props.step === 2 ? (
            <Link to="/prepare/experiments">
              <div className="col-xs-6 col-md-6">
                <div id="previous-button-div" className="previous-button-div">
                  <button id="previous-button" className="btn btn-lg btn-success" type="button">
                    <i className="icon-next" /> Previous
                  </button>
                </div>
              </div>
            </Link>
          ) : (
            <Link to="/prepare/main/loadSampleChanger">
              <div className="col-xs-6 col-md-6">
                <div id="next-button-div" className="next-button-div">
                  <button id="next-button" className="btn btn-lg btn-success" type="button">
                    <i className="icon-next" /> Next
                  </button>
                </div>
              </div>
            </Link>
          )}
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    application: state.application,
    user: state.user,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    setBreadCrumbs: breadCrumbs => dispatch(setBreadCrumbs(breadCrumbs)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MXNavigationContainer)

MXNavigationContainer.propTypes = {
  step: PropTypes.number,
}
